export default __webpack_public_path__ + "static/james-bailey-bc9e6ae7cec4bb2f34200e597eb0cc31.png";